import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { PROJECT_NAME, PROJECT_IMAGE } from "@/lib/api";

const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const [project, setProject] = useState({ name: PROJECT_NAME, imageUrl: PROJECT_IMAGE });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      let url = data.project_image_url || PROJECT_IMAGE;
      if (url && url.startsWith("/api")) url = `${process.env.REACT_APP_BACKEND_URL}${url}`;
      setProject({ name: data.project_name || PROJECT_NAME, imageUrl: url });
    } catch {
      /* keep defaults */
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ProjectContext.Provider value={{ project, refresh }}>
      {children}
    </ProjectContext.Provider>
  );
}

export const useProject = () => useContext(ProjectContext);
